import axios from 'axios';
import * as Sentry from '@sentry/react';
import uniqBy from 'lodash/uniqBy';

// Gets an individual phase on project phase click
export default (projectNumber, phaseNumber) =>
	axios
		.get(
			`/jsonapi/node/project_phase?filter[project-number][condition][path]=field_pp_project_number&filter[project-number][condition][value]=${projectNumber}&filter[phase-number][condition][path]=field_pp_phase&filter[phase-number][condition][value]=${phaseNumber}`
		)
		.then(response => {
			if (response?.data?.data?.length > 0) {
				const phase = response.data.data[0];

				return axios.get(`/forms_rest_api/phase_packets?id=${phase.id}`).then(({ data }) => {
					const packets =
						data && Array.isArray(data)
							? data.map(x => ({
									packet_nid: x.packet_nid,
									packet_id: x.packet_id,
									revision_timestamp: x.revision_timestamp,
									title: x.title,
									created: x.created,
									changed: x.changed,
									packet_project_phase: x.packet_project_phase,
									packet_tag: x.packet_tag,
									submitted: x.submitted
								}))
							: [];

					const clients = JSON.parse(phase.attributes.field_pp_clients ?? '[]');
					const unit_table = JSON.parse(phase.attributes.field_pp_unit_table ?? '[]');
					const contactsList = JSON.parse(phase.attributes.field_pp_contacts ?? '[]');
					const contacts = uniqBy(
						contactsList.map(x => ({
							...x,
							name: `${x.first_name} ${x.last_name}`
						})),
						'name'
					);

					let tasks = JSON.parse(phase.attributes.field_pp_tasks ?? '[]');
					if (!Array.isArray(tasks)) {
						tasks = [];
					} else {
						tasks = uniqBy(tasks, 'number');
					}

					const city = phase.attributes.field_pp_city;
					const state = phase.attributes.field_pp_state;

					return {
						id: phase.id,
						nid: phase.attributes.drupal_internal__nid,
						location: `${city}, ${state}`,
						address1: phase.attributes.field_pp_address1,
						address2: phase.attributes.field_pp_address2,
						city,
						state,
						zip: phase.attributes.field_pp_zip,
						client_id: phase.attributes.field_pp_client_id,
						clients,
						contact_work_phone: phase.attributes.field_pp_contact_work_phone,
						contact_id: phase.attributes.field_pp_contact_id,
						contacts,
						unit_table_name: phase.attributes.field_pp_unit_table_name,
						unit_table,
						cust_naics: phase.attributes.field_pp_cust_naics,
						organization: phase.attributes.field_pp_organization,
						owner_id: phase.attributes.field_pp_owner_id,
						phase: phase.attributes.field_pp_phase,
						phase_long_name: phase.attributes.field_pp_phase_long_name,
						phase_short_name: phase.attributes.field_pp_phase_short_name,
						pm_number: phase.attributes.field_pp_pm_number,
						supervisor_number: phase.attributes.field_pp_supervisor_number,
						project_number: phase.attributes.field_pp_project_number,
						project_long_name: phase.attributes.field_pp_project_long_name,
						project_short_name: phase.attributes.field_pp_project_short_name,
						project_type: phase.attributes.field_pp_project_type,
						tasks,
						packets,
						status: phase.attributes.field_pp_status,
						downloadedAt: Date.now()
					};
				});
			} else {
				return null;
			}
		})
		.catch(error => {
			Sentry.captureException(error);
			throw new Error('Failed to load project phase');
		});
